{
  "generic": "An unexpected error occurred",
  "network": "Network error. Check your connection.",
  "notFound": "Page not found",
  "forbidden": "Access denied",
  "tryAgain": "Try again"
}
